/**
 * 底图源
 * @type {{}}
 */
const extend = require('../../base/util/Extend')
//常用底图服务，包括天地图、百度、谷歌、高德等，可参考leaflet provider
const baseLayerProviders = {
    //天地图采用wmts而非xyz调用
    TIANDITU: {
        //矢量-4326
        VEC_C: {
            layers: "vec",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/vec_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        },
        //矢量注记-4326
        CVA_C: {
            layers: "cva",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/cva_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        },
        //影像-4326
        IMG_C: {
            layers: "img",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/img_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        },
        //影像注记-4326
        CIA_C: {
            layers: "cia",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/cia_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        },
        //地形-4326
        TER_C: {
            layers: "ter",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/ter_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        },
        //地形注记-4326
        CTA_C: {
            layers: "cta",
            matrixSet: "c",
            format: "tiles",
            tileType: 102,
            crossOrigin: "*",
            url: "http://t0.tianditu.gov.cn/cta_c/wmts?tk={token}",
            projection: "EPSG:4326",
            token: ""
        }
    },
    //todo
    BAIDU: {},
    GAODE: {},
    GOOGLE: {},
    WMS: {},
    WMTS: {
        "layers": "",
        "matrixSet": "",
        "format": "",
        "tileType": 102,
        "crossOrigin": "*",
        "url": "",
        "projection": "EPSG:4326"
    },
    XYZ: {}

};
/**
 * 扩展默认配置
 * @method
 * @param key {String} 默认底图key，如天地图矢量为TIANDITU.VEC_C，WMTS为WMTS
 * @param opt
 * @returns {*}
 */
baseLayerProviders.extend = function (key, opt) {
    let keys = key.split(".");
    let config = baseLayerProviders;
    try {
        for (let i = 0; i < keys.length; i++) {
            config = config[keys[i]];
        }
    } catch (e) {
        throw(new Error('key = ' + key + ' 不存在！'));
    }
    let temp = extend(true, {}, config);
    return extend(true, temp, opt || {});

}
module.exports = baseLayerProviders;